















import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
// @ts-ignore
import SwaggerUI from '@/components/Documentation/SwaggerUI.vue';

@Component({ name: 'SwaggerCoreApi', components: { SwaggerUI }, metaInfo: { title: 'Core API' } })
export default class extends SaascadaVue {

    get url() {
        return process.env.VUE_APP_CORE_BASE_URL + '/openapi';
    }

}
